import * as angular from 'angular';
import {SplitService} from "../../commons/services/split-service.service";
import {ItemSetting} from "../../price-plan/models/itemSetting.model";
import {FieldCategoryType} from "../types/field-category.type";

export class PackageConfigurationService {


  /* @ngInject */
  constructor(private splitService: SplitService) {
  }

  getPackageConfigurationsBySize() {
    const sitePackageItems = this.splitService.getSitePackageItems();
    const sitePackageConfigurations = this.splitService.getSitePackageConfigurations();

    const packageConfigurationByType = {};
    sitePackageItems.forEach((oip: ItemSetting) => {
      if (oip.packageConfigurationId) {
        packageConfigurationByType[oip.id] = {}
        const packageConfigFields = sitePackageConfigurations.find((pc) => pc.id === oip.packageConfigurationId).fields
        packageConfigFields.forEach((f) => {
          packageConfigurationByType[oip.id][f.name] = f;
        })
      } else {
        packageConfigurationByType[oip.id] = {}
        const packageConfigFields = this.splitService.getSiteDefaultPackageConfigurationFields()
        packageConfigFields.forEach((f) => {
          packageConfigurationByType[oip.id][f.name] = f;
        })
      }
    })

    return packageConfigurationByType;
  }

  getPackageConfigurationsCustomFieldsBySize() {
    const sitePackageItems = this.splitService.getSitePackageItems();
    const sitePackageConfigurations = this.splitService.getSitePackageConfigurations();

    const packageConfigurationByType = {};
    sitePackageItems.forEach((oip: ItemSetting) => {
      if (oip.packageConfigurationId) {
        packageConfigurationByType[oip.id] = [];
        const packageConfigFields = sitePackageConfigurations.find((pc) => pc.id === oip.packageConfigurationId).fields
        packageConfigurationByType[oip.id] = packageConfigFields.filter((f) => f.category === FieldCategoryType.Custom)
      }
    })

    return packageConfigurationByType;
  }

  getEmptyPackageConfiguredFieldsWithoutValues(packageSize) {
    const packageConfigurationCustomFieldsByType = this.getPackageConfigurationsCustomFieldsBySize();
    const field = packageConfigurationCustomFieldsByType[packageSize];
    return field?.map(f => {
      return {
        "fieldName": f.name,
        "type": f.type
      }
    }) || undefined;
  }

  setPackageCustomFields(packageList) {
    const packageListCopy = angular.copy(packageList);
    packageListCopy.forEach(pa => {
      pa.items.forEach((item) => {

        const configuredFields = this.getEmptyPackageConfiguredFieldsWithoutValues(item.size);

        if (item.configuredFields && item.configuredFields.length) {
          item.configuredFields.forEach((cf) => {
            const index = configuredFields.findIndex((f) => {
              return f.fieldName === cf.fieldName
            })
            if (index !== -1 && typeof cf.value !== 'undefined') {
              configuredFields[index].value = cf.value;
            }
          })
        }
        if (configuredFields) {
          item.configuredFields = configuredFields;
        }

      })
    })
    return packageListCopy;
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .service('packageConfigurationService', PackageConfigurationService);
